import { render, staticRenderFns } from "./PaymentDetail.vue?vue&type=template&id=c920f82e&scoped=true&"
import script from "./PaymentDetail.vue?vue&type=script&lang=js&"
export * from "./PaymentDetail.vue?vue&type=script&lang=js&"
import style0 from "./PaymentDetail.vue?vue&type=style&index=0&id=c920f82e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c920f82e",
  null
  
)

export default component.exports